import afterLaundry from '../assets/afterLaundry.webp';
import beforeLaundry from '../assets/beforeLaundry.webp';
import afterShower from '../assets/afterShower.webp';
import beforeShower from '../assets/beforeShower.webp';
import beforeReading from '../assets/beforeReading.webp';
import afterReading from '../assets/afterReading.webp';
import beforeWinecellar from '../assets/beforeWinecellar.webp';
import afterWinecellar from '../assets/afterWinecellar.webp';
import beforeBriggsBeam from '../assets/beforeBriggsBeam.webp';
import afterBriggsBeam from '../assets/afterBriggsBeam.webp';
import afterBriggsBeam2 from '../assets/afterBriggsBeam2.webp';
import beforePatio1 from '../assets/beforePatio1.webp';
import beforePatio2 from '../assets/beforePatio2.webp';
import beforePatio3 from '../assets/beforePatio3.webp';
import beforePatio4 from '../assets/beforePatio4.webp';
import afterPatio1 from '../assets/afterPatio1.webp';
import afterPatio2 from '../assets/afterPatio2.webp';
import afterPatio3 from '../assets/afterPatio3.webp';
import afterPatio4 from '../assets/afterPatio4.webp';
import beforeKitchen1 from '../assets/beforeKitchen1.webp';
import beforeKitchen2 from '../assets/beforeKitchen2.webp';
import afterKitchen1 from '../assets/afterKitchen1.webp';
import afterKitchen2 from '../assets/afterKitchen2.webp';
import afterKitchen4 from '../assets/afterKitchen4.webp';
import afterKitchen5 from '../assets/afterKitchen5.webp';
import beforeBasement from '../assets/beforeBasement.webp';
import afterBasement from '../assets/basementRemodel.webp';
import afterEntertainment1 from '../assets/entertainment1.webp';
import afterEntertainment2 from '../assets/entertainment2.webp';
import glenwoodKitchen from '../assets/glenwoodKitchen.webp';
import glenwoodBasement from '../assets/glenwoodBasement.webp';
import glenwoodBathroom from '../assets/glenwoodBathroom.webp';
import glenwoodBedroom from '../assets/glenwoodBedroom.webp';
import glenwoodBedroom2 from '../assets/glenwoodBedroom2.webp';

export const sections = [
    {id: 0, link: '', title: 'HOME'},
    {id: 1, link: 'about', title: 'ABOUT US'},
    {id: 2, link: 'structural', title: 'STRUCTURAL SERVICES'},
    {id: 3, link: 'remodeling', title: 'REMODELING'},
    {id: 4, link: 'concrete', title: 'CONCRETE'},
    {id: 5, link: 'home-additions', title: 'HOME ADDITIONS'},
    {id: 6, link: 'gallery', title: 'GALLERY'},
    {id: 7, link: 'areas', title: 'SERVICE AREAS'},
    {id: 8, link: 'reviews', title: 'REVIEWS'},
    {id: 9, link: 'contact', title: 'CONTACT US'},
]

export const reasons = [
    {id: 0, reason: 'Have over 15 years of experience'},
    {id: 1, reason: 'Are Licensed and insured'},
    {id: 2, reason: 'Will work with your timeline and budget'},
    {id: 3, reason: 'Always maintain excellent communication'},
]

export const services = [
    {id: 0, service: 'Structural wall installation services', link: 'structural'},
    {id: 1, service: 'Load-bearing beam installation services', link: 'structural'},
    {id: 2, service: 'Concrete flatwork services', link: 'concrete'},
    {id: 3, service: 'Home addition services', link: 'home-additions'},
    {id: 4, service: 'Home remodeling services', link: 'remodeling'},
]

export const cities = [
    {id: 0, city: 'Arvada, CO'},
    {id: 1, city: 'Aurora, CO'},
    {id: 2, city: 'Brighton, CO'},
    {id: 3, city: 'Broomfield, CO'},
    {id: 4, city: 'Casle Pines, CO'},
    {id: 5, city: 'Castle Rock, CO'},
    {id: 6, city: 'Centennial, CO'},
    {id: 7, city: 'Denver, CO'},
    {id: 8, city: 'Elbert, CO'},
    {id: 9, city: 'Elizabeth, CO'},
    {id: 10, city: 'Englewood, CO'},
    {id: 11, city: 'Golden, CO'},
    {id: 12, city: 'Greenwood Village, CO'},
    {id: 13, city: 'Highlands Ranch, CO'},
    {id: 14, city: 'Lakewood, CO'},
    {id: 15, city: 'Littleton, CO'},
    {id: 16, city: 'Parker, CO'},
    {id: 17, city: 'Thorton, CO'},
    {id: 18, city: 'Westminster, CO'},
    {id: 19, city: 'Wheat Ridge, CO'},
]

export const reviews = [
    {id: 0, name: '-Madeline C.', review:`"Vance was awesome to work with! He was up front about the work, kept me in the loop, and executed. We contracted Alignment Construction to replace a load bearing wall with a beam across the ceiling to open up our kitchen. He helped me work with the permitting office and kept me up to date on the construction progress. He kept the big picture in mind, but went the extra mile for the small details. An example of that was taking the time to match the beam's stain to our to be installed wood floor. If you want the job done right, Vance is the right fit."`},
    {id: 1, name: '-Kelly M.', review:`"Vance helped me with a structural wall removal in my house. He was super quick to respond to my initial inquiry and to come out and inspect the wall. He worked with my engineer, my budget, and my desired timeframe to make our vision come to life. Any updates or obstacles were well communicated and he answered every question I thought of. He and his team were very efficient and professional, and I wouldn't hesitate to hire Alignment Construction LLC again or recommend them to a friend."`},
    {id: 2, name: '-Bridget M.', review:`"What a great idea it was to contact Vance! We thought we had a load bearing wall that we've been wanting to remove. Vance quickly made time to come to our home with engineer Tom to check out the project. With some inspection, he gave us the fantastic news the wall was not load bearing. We were thrilled with his honesty and the fact that he didn't try to sell us work we could do ourselves. Would not hesitate to call Alignment Construction again for a project and have already referred neighbors to contact him for their load bearing wall needs."`},
    {id: 3, name: '-Lori B.', review:`"Absolutely impressive in all aspects of the work performed: good quality, on time, answered all questions and explained the process and finished the job per the plan. I would definitely use Vance at Alignment Construction for any future work!!"`}
]

export const gallery = [
    {id: 0, location: 'Littleton Remodel', desc: 'Kitchen | Before', photo: `${beforeKitchen2}`},
    {id: 1, location: 'Littleton Remodel', desc: 'Kitchen | After', photo: `${afterKitchen2}`},
    {id: 2, location: 'Glenwood Remodel', desc: 'Kitchen: Before | After', photo: `${glenwoodKitchen}`},
    {id: 3, location: 'Glenwood Remodel', desc: 'Bathroom: Before | After', photo: `${glenwoodBathroom}`},
    {id: 4, location: 'Glenwood Remodel', desc: 'Bedroom: Before | After', photo: `${glenwoodBedroom}`},
    {id: 5, location: 'Glenwood Remodel', desc: 'Bedroom: Before | After', photo: `${glenwoodBedroom2}`},
    {id: 6, location: 'Glenwood Remodel', desc: 'Basement: Before | After', photo: `${glenwoodBasement}`},
    {id: 7, location: 'Aldretti Kitchen Remodel', desc: 'Kitchen | After', photo: `${afterKitchen4}`},
    {id: 8, location: 'Littleton Kitchen Remodel', desc: 'Kitchen | After', photo: `${afterKitchen5}`},
    {id: 9, location: 'Littleton Renovation', desc: 'Entertainment Center | After', photo: `${afterEntertainment1}`},
    {id: 10, location: 'Washington Kitchen', desc: 'Kitchen | Before', photo: `${beforeKitchen1}`},
    {id: 11, location: 'Washington Kitchen', desc: 'Kitchen | After', photo: `${afterKitchen1}`},
    {id: 12, location: 'Apartment Remodel', desc: 'Living Room | Before', photo: `${beforeBasement}`},
    {id: 13, location: 'Apartment Remodel', desc: 'Living Room | After', photo: `${afterBasement}`},
    {id: 14, location: 'Lucas Patio', desc: 'Patio | Before', photo: `${beforePatio3}`},
    {id: 15, location: 'Lucas Patio', desc: 'Patio | After', photo: `${afterPatio3}`},
    {id: 16, location: 'New Build Modification', desc: 'Entertainment Center | After', photo: `${afterEntertainment2}`},
    {id: 17, location: 'Jensen Patio Renovation', desc: 'Patio | Before', photo: `${beforePatio1}`},
    {id: 18, location: 'Jensen Patio Renovation', desc: 'Patio | After', photo: `${afterPatio1}`},
    {id: 19, location: 'Jensen Patio Renovation', desc: 'Patio 2 | Before', photo: `${beforePatio2}`},
    {id: 20, location: 'Jensen Patio Renovation', desc: 'Patio 2 | After', photo: `${afterPatio2}`},
    {id: 21, location: 'Briggs Beam Installation', desc: 'Beam | Before', photo: `${beforeBriggsBeam}`},
    {id: 22, location: 'Briggs Beam Installation', desc: 'Beam | After', photo: `${afterBriggsBeam}`},
    {id: 23, location: 'Briggs Beam Installation', desc: 'Beam 2 | After', photo: `${afterBriggsBeam2}`},
    {id: 24, location: 'Maloney Patio', desc: 'Patio | Before', photo: `${beforePatio4}`},
    {id: 25, location: 'Maloney Patio', desc: 'Patio | After', photo: `${afterPatio4}`},
    {id: 26, location: 'Boulder Remodel', desc: 'Reading Nook | Before', photo: `${beforeReading}`},
    {id: 27, location: 'Boulder Remodel', desc: 'Reading Nook | After', photo: `${afterReading}`},
    {id: 28, location: 'Boulder Remodel', desc: 'Wine Cellar | Before', photo: `${beforeWinecellar}`},
    {id: 29, location: 'Boulder Remodel', desc: 'Wine Cellar | After', photo: `${afterWinecellar}`},
    {id: 30, location: 'Boulder Remodel', desc: 'Shower | Before', photo: `${beforeShower}`},
    {id: 31, location: 'Boulder Remodel', desc: 'Shower | After', photo: `${afterShower}`},
    {id: 32, location: 'Boulder Remodel', desc: 'Laundy Room | Before', photo: `${beforeLaundry}`},
    {id: 33, location: 'Boulder Remodel', desc: 'Laundy Room | After', photo: `${afterLaundry}`},
]

